import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigsService } from '../providers/configs.service';
import { SessionService } from '../providers/session.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DocumentoService {

	constructor(
		public http: HttpClient,
		public session: SessionService,
		public configs: ConfigsService) 
    { }
    
    getNativeWindow() {
        return window;
    }

	
    getTipos(cod_tipo_doc, descricao, page){
        cod_tipo_doc = (cod_tipo_doc == null || cod_tipo_doc == '') ? '' : '&cod_tipo_doc=' + cod_tipo_doc
        descricao = (descricao == null || descricao == '') ? '' : '&descricao=' + descricao
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'tipos-documentos?'+ '&_page=' + page)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                })
        })
	}
	
    getListaTipos(){
        // cod_tipo_doc = (cod_tipo_doc == null || cod_tipo_doc == '') ? '' : '&cod_tipo_doc=' + cod_tipo_doc
        // descricao = (descricao == null || descricao == '') ? '' : '&descricao=' + descricao
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'lists/tipos-documentos')
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                })
        })
	}
    getImagem(tipo_doc, titulo, page){
        tipo_doc = (tipo_doc == null || tipo_doc == '') ? '' : '&tipo_doc=' + tipo_doc
        titulo = (titulo == null || titulo == '') ? '' : '&titulo=' + titulo
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'documentos?' + tipo_doc + titulo + '&_page=' + page)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                })
        })
    }
    
    downloadDoc(id){
        let nativeWindow = this.getNativeWindow()
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'documentos/'+ id + '/download')
                .subscribe(data => {
                    console.log("chegou", data)
                    resolve(data);
                },
                error => {
                    console.log('erro')
                    // var newWindow = nativeWindow.open('/#/link/');
                    // // this.Service.assignActivity(type).subscribe(res => {

                    // newWindow.location =  '/#/link/' +   error;
                    reject(error)
                })
        })
    }
    public getPDF(id): Observable<Blob> {   
        //const options = { responseType: 'blob' }; there is no use of this
        let uri = this.configs.getEndpoint() + 'documentos/'+ id + '/download';
        // this.http refers to HttpClient. Note here that you cannot use the generic get<Blob> as it does not compile: instead you "choose" the appropriate API in this way.
        return this.http.get(uri, { responseType: 'blob' });
    }
       
    get(){
        // cod_tipo_doc = (cod_tipo_doc == null || cod_tipo_doc == '') ? '' : '&cod_tipo_doc=' + cod_tipo_doc
        // descricao = (descricao == null || descricao == '') ? '' : '&descricao=' + descricao
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'tipos-documentos')
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                })
        })
    }
    
	
	salvarTipo(tipo) {
        console.log('tipo salvar', tipo)
        return new Promise((resolve, reject) => {
            let body = tipo;

            this.http.post(this.configs.getEndpoint() + 'tipos-documentos', body)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        })
    }

    uploadDocumento(doc){
        return new Promise((resolve, reject) => {
            let body = doc;

            this.http.post(this.configs.getEndpoint() + 'documentos', body)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        })
    }

    putTipo(tipo){
        return new Promise((resolve, reject) => {
            let body = tipo;
            this.http.put(this.configs.getEndpoint() + 'tipos-documentos/' + tipo['_id'], body)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error);
                });
        });
    }

    deleteDocumento(id) {
        return new Promise((resolve, reject) => {
            this.http.delete(this.configs.getEndpoint() + 'documentos/' + id)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        });
    }

    
    getTipoByID(id) {
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'tipos-documentos/' + id)
                .subscribe(data => {
                    
                    resolve(data);
                    
                },
                error => {
                    reject(error);
                });
        });
    }

    
    deleteTipo(id) {
        return new Promise((resolve, reject) => {
            this.http.delete(this.configs.getEndpoint() + 'tipos-documentos/' + id)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        });
    }

}
